export default __webpack_public_path__ + "static/media/dongle_dance.ab11fef1.png";